import { dayjs } from '@shared/utils';

export function getDateOptions(month: number, year: number) {
  const daysInMonth = dayjs(`${year}-${month}-01`).daysInMonth();
  const dates = Array.from({ length: daysInMonth }, (_, i) => ({
    value: `${i + 1}`,
    label: `${i + 1}`,
  }));

  return dates;
}

export function getMonthLabel(month: number) {
  return dayjs().month(month).format('MMMM');
}

export function getMonthOptions() {
  const months = Array.from({ length: 12 }, (_, i) => ({
    value: `${i}`,
    label: getMonthLabel(i),
  }));

  return months;
}

const DEFAULT_YEAR_CHOICE_LIMIT = 80;

const DEFAULT_EXPIRY_YEAR_CHOICE_LIMIT = 20;

export function getYearOptions(yearChoicesLimit: number = DEFAULT_YEAR_CHOICE_LIMIT) {
  const currentYear = dayjs().year();
  const years = Array.from({ length: yearChoicesLimit }, (_, i) => ({
    value: `${i + currentYear - (yearChoicesLimit - 1)}`,
    label: dayjs()
      .year(i + currentYear - (yearChoicesLimit - 1))
      .format('BBBB'),
  })).sort((a, b) => b.value.localeCompare(a.value));

  return years;
}

export function getExpiryYearOptions(yearChoicesLimit: number = DEFAULT_EXPIRY_YEAR_CHOICE_LIMIT) {
  const currentYear = dayjs().year();
  const years = Array.from({ length: yearChoicesLimit }, (_, i) => ({
    value: `${i + currentYear}`,
    label: dayjs()
      .year(i + currentYear)
      .format('BBBB'),
  })).sort((a, b) => a.value.localeCompare(b.value));

  return years;
}
